import { defineMessages } from 'react-intl-next';

export const i18n: {
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterByIcon: {
		id: 'quick-find-filters.filter-by-icon-label',
		defaultMessage: 'Filter by Icon',
		description: 'Label for filter by icon',
	},
});
